import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PanelsNumberFormatter = ({ row }) => {
    const { t } = useTranslation();
    const panels_counter = get(row, 'total_panels', 0);
    if (!panels_counter) return '---';
    return (
        <Typography variant="caption">
            {panels_counter}{' '}
            {t('Panel', {
                count: panels_counter,
            })}
        </Typography>
    );
};

PanelsNumberFormatter.propTypes = {
    row: PropTypes.object,
};

export default PanelsNumberFormatter;
